import React, {SVGProps} from 'react';

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="22"
      viewBox="0 0 13 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.6213 1.06055L2.12134 10.5605L11.6213 20.0605" stroke="#FF4F12" strokeWidth="3" />
    </svg>
  );
};
